(() => {
  if (window.__STONEMINE_FRONTEND_FUNNEL__) return;
  window.__STONEMINE_FRONTEND_FUNNEL__ = true;
  const once = new Set();
  function emit(name, parameters = {}) {
    try {
      // Analytics envelopes can include the page URL. Never emit from parameterized/private views.
      if (window.location.search || window.location.hash || /\/(?:account|customers)(?:\/|$)/.test(window.location.pathname)) return;
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      // Reuse an existing analytics installation; never install or invent an ID.
      if (typeof window.gtag === 'function') window.gtag('event', name, parameters);
      else if (Array.isArray(window.dataLayer)) window.dataLayer.push({event:name,...parameters});
      else if (typeof window.Shopify?.analytics?.publish === 'function') {
        const published = window.Shopify.analytics.publish(`stonemine:${name}`, parameters);
        published?.catch?.(() => {});
      }
    } catch { /* Analytics must not interrupt an edit or navigation. */ }
  }
  function emitOnce(name) {
    if (once.has(name)) return;
    once.add(name);
    emit(name);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let destination;
    try { destination = new URL(link.href, window.location.href); } catch { return; }
    if (destination.origin !== window.location.origin || !destination.pathname.endsWith('/pages/design')) return;
    const position = link.closest('header') ? 'header' : link.closest('footer') ? 'footer' : 'content';
    emit('designer_entry_click', {entry_position:position});
  });
  window.addEventListener('stonemine:first-local-bead', () => emitOnce('designer_first_bead'));
  const root = document.querySelector('[data-stonemine-customizer]');
  if (root) {
    const ready = () => {
      const control = root.querySelector('.crystal-card-main');
      if (!control || control.closest('[inert]') || control.disabled) return false;
      emitOnce('designer_ready');
      return true;
    };
    if (!ready()) {
      const observer = new MutationObserver(() => { if (ready()) observer.disconnect(); });
      observer.observe(root, {childList:true,subtree:true,attributes:true,attributeFilter:['inert','disabled']});
      window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
    }
  }
})();
